// import React, { useState } from "react";
// import { Modal, Button, Select, Checkbox, Form, Typography } from "antd";
// import Papa from "papaparse";
// import { saveAs } from "file-saver";

// const { Option } = Select;

// const ExportProductsModal = ({ visible, onClose, catogories, products }) => {
//     const [selectedColumns, setSelectedColumns] = useState();
//     const [selectedTypes, setSelectedTypes] = useState();
//     const [selectedCategories, setSelectedCategories] = useState();
//     const [exportMeta, setExportMeta] = useState(false);
//     const [csvData, setCsvData] = useState({
//         headers: [],
//         products: []
//     });
//     const [selectAll, setSelectAll] = useState(false); // State for "Select All"

//     const columns = [
//         "ID", "Type", "SKU", "GTIN, UPC, EAN, or ISBN", "Name", "Published",
//         "Is featured?", "Visibility in catalog", "Short description", "Description",
//         "Date sale price starts", "Date sale price ends", "Tax status", "Tax class",
//         "In stock?", "Stock", "Low stock amount", "Backorders allowed?",
//         "Sold individually?", "Weight (lbs)", "Length (in)", "Width (in)", "Height (in)",
//         "Allow customer reviews?", "Purchase note", "Sale price", "Regular price", "Categories",
//         "Tags", "Shipping class", "Images", "Download limit", "Download expiry days", "Parent",
//         "Grouped products", "Upsells", "Cross-sells", "External URL", "Button text", "Position"
//     ];


//     const handleSelectAll = (e) => {
//         const checked = e.target.checked;
//         setSelectAll(checked);
//         setSelectedColumns(checked ? columns : []); // Select all or clear
//     };
//     const parentsCatogories = catogories?.filter((cat) => cat.parent === 0);

//     const generateCSVData = () => {
//         // Keep headers unchanged
//         const headers = selectedColumns.map(col => ({
//             label: col,
//             key: col.toLowerCase().replace(/ /g, "_"),
//         }));


//         const filteredProducts = products.filter(product => 
//             selectedTypes.includes(product.type) &&
//             product.categories.some(category => selectedCategories.includes(Number(category.id)))
//         );


//         if (filteredProducts.length === 0) {
//             console.warn("No products matched the filters.");
//             return;
//         }

//         // Mapping of expected CSV field names to actual product object keys
//         const fieldMapping = {
//             "productId": "id",
//             "name": "name",
//             "sku": "sku",
//             "type": "type",
//             "regular_price": "regular_price",
//             "sale_price": "sale_price",
//             "stock": "stock_quantity",
//             "stock_status": "in_stock?",
//             "categories": "categories",
//             "images": "images",
//             "description": "description",
//             "short_description": "short_description",
//             "button_text": "button_text",
//             "purchase_note": "purchase_note",
//             "tax_status": "tax_status",
//             "tax_class": "tax_class",
//             "visibility_in_catalog": "visibility_in_catalog",
//             "sold_individually": "sold_individually?",
//             "low_stock_amount": "low_stock_amount",
//             "backorders_allowed": "backorders_allowed?",
//             "external_url": "external_url",
//             "grouped_products": "grouped_products",
//             "upsells": "upsells",
//             "cross_sells": "cross-sells",
//             "weight_(lbs)": "weight_(lbs)",
//             "length_(in)": "length_(in)",
//             "width_(in)": "width_(in)",
//             "height_(in)": "height_(in)",
//             "gtin,_upc,_ean,_or_isbn": "gtin,_upc,_ean,_or_isbn",
//             "download_limit": "download_limit",
//             "download_expiry_days": "download_expiry_days",
//             "date_sale_price_starts": "date_sale_price_starts",
//             "date_sale_price_ends": "date_sale_price_ends",
//         };

//         // Ensure correct data mapping for each product
//         const data = filteredProducts.map(product => {
//             let mappedProduct = {};

//             headers.forEach(header => {
//                 let csvField = header.key;
//                 let productKey = fieldMapping[csvField] || csvField; // Get the actual key in the product object

//                 if (productKey in product) {
//                     mappedProduct[csvField] = product[productKey] ?? "";
//                 } else {
//                     // Handle special cases for nested or derived fields
//                     switch (csvField) {
//                         case "categories":
//                             mappedProduct[csvField] = product.categories.map(cat => cat.name).join(", ");
//                             break;
//                         case "images":
//                             mappedProduct[csvField] = product.images.map(img => img.src).join(", ");
//                             break;
//                         case "stock_status":
//                             mappedProduct[csvField] = product.stock > 0 ? "in stock" : "out of stock";
//                             break;
//                         case "description":
//                             mappedProduct[csvField] = product.description
//                                 ? product.description.replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
//                                 : "";
//                             break;
//                         default:
//                             mappedProduct[csvField] = "";
//                     }
//                 }
//             });

//             return mappedProduct;
//         });

//         console.log("CSV Data:", data);

//         setCsvData({
//             headers: headers.map(header => header.label),
//             products: data,
//         });

//     };


//     const downloadCSV = () => {
//         debugger
//         if (!csvData || !csvData.products || csvData.products.length === 0) {
//             console.warn("No data available for CSV export.");
//             return;
//         }

//         console.log("CSV Headers:", csvData.headers);
//         console.log("CSV Products:", csvData.products);

//         const csv = Papa.unparse({
//             fields: csvData.headers,  // Ensure headers are valid
//             data: csvData.products    // Ensure products contain the expected fields
//         });

//         console.log("Generated CSV:", csv);

//         // const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//         // saveAs(blob, "exported-products.csv");
//     };

//     return (
//         <Modal
//             title="Export products to a CSV file"
//             open={visible}
//             onCancel={() => onClose(false)}
//             footer={null}
//         >
//             <Typography.Title level={5}>This tool allows you to generate and download a CSV file containing a list of all products.</Typography.Title>
//             <Form style={{ marginTop: 20 }} layout="vertical">
//                 <Form.Item label="Which columns should be exported?">
//                     <Checkbox checked={selectAll} onChange={handleSelectAll}>
//                         Select All
//                     </Checkbox>
//                     <Select
//                         mode="multiple"
//                         value={selectedColumns}
//                         onChange={setSelectedColumns}
//                         style={{ width: "100%" }}
//                     >
//                         {columns.map(col => (
//                             <Option key={col} value={col}>{col}</Option>
//                         ))}
//                     </Select>
//                 </Form.Item>

//                 <Form.Item label="Which product types should be exported?">
//                     <Select
//                         mode="multiple"
//                         value={selectedTypes}
//                         onChange={setSelectedTypes}
//                         style={{ width: "100%" }}
//                     >
//                         <Option value="simple">Simple product</Option>
//                         <Option value="variable">Variable product</Option>
//                         <Option value="auction">Auction</Option>
//                     </Select>
//                 </Form.Item>

//                 <Form.Item label="Which product category should be exported?">
//                     <Select
//                         mode="multiple"
//                         value={selectedCategories}
//                         onChange={setSelectedCategories}
//                         style={{ width: "100%" }}
//                     >
//                         {parentsCatogories?.map((subSub) => (
//                             <Option key={subSub.id} value={subSub.id}>
//                                 {subSub.name}
//                             </Option>
//                         ))}
//                     </Select>
//                 </Form.Item>

//                 <Form.Item>
//                     <Checkbox checked={exportMeta} onChange={e => setExportMeta(e.target.checked)}>
//                         Yes, export all custom meta
//                     </Checkbox>
//                 </Form.Item>

//                 <Form.Item>
//                     <Button onClick={generateCSVData} type="primary" block style={{ background: "#1677ff", color: "white" }}>
//                         Generate CSV
//                     </Button>
//                     <Form.Item>
//                         <Button onClick={downloadCSV} type="primary" block>
//                             Download CSV
//                         </Button>
//                     </Form.Item>
//                 </Form.Item>
//             </Form>
//         </Modal>
//     );
// };

// export default ExportProductsModal;



import React, { useState } from "react";
import { Modal, Button, Select, Checkbox, Form, Typography, Flex } from "antd";
import Papa from "papaparse";
import { saveAs } from "file-saver";

const { Option } = Select;

const ExportProductsModal = ({ visible, onClose, categories, products }) => {

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [exportMeta, setExportMeta] = useState(false);
    const [csvData, setCsvData] = useState({ headers: [], products: [] });
    const [selectAll, setSelectAll] = useState(false);

    const parentCategories = categories?.filter((cat) => cat.parent === 0);

    const columns = [
        "ID", "Type", "SKU", "GTIN, UPC, EAN, or ISBN", "Name", "Published",
        "Is featured?", "Visibility in catalog", "Short description", "Description",
        "Date sale price starts", "Date sale price ends", "Tax status", "Tax class",
        "In stock?", "Stock", "Low stock amount", "Backorders allowed?",
        "Sold individually?", "Weight (lbs)", "Length (in)", "Width (in)", "Height (in)",
        "Allow customer reviews?", "Purchase note", "Sale price", "Regular price", "Categories",
        "Tags", "Shipping class", "Images", "Download limit", "Download expiry days", "Parent",
        "Grouped products", "Upsells", "Cross-sells", "External URL", "Button text", "Position"
    ];

    const handleSelectAll = (e) => {
        setSelectAll(e.target.checked);
        setSelectedColumns(e.target.checked ? columns : []);
        
    };


    const fieldMapping = {
        "ID": "productId",
        "Type": "type",
        "SKU": "sku",
        "GTIN, UPC, EAN, or ISBN": "gtin",
        "Name": "name",
        "Published": "status",
        "Is featured?": "featured",
        "Visibility in catalog": "catalog_visibility",
        "Short description": "short_description",
        "Description":"description",
        "Date sale price starts": "date_on_sale_from",
        "Date sale price ends": "date_on_sale_to",
        "Tax status": "tax_status",
        "Tax class": "tax_class",
        "In stock?": "stock_status",
        "Stock": "stock_quantity",
        "Low stock amount": "low_stock_amount",
        "Backorders allowed?": "backorders",
        "Sold individually?": "sold_individually",
        "Weight (lbs)": "weight",
        "Length (in)": "dimensions.length",
        "Width (in)": "dimensions.width",
        "Height (in)": "dimensions.height",
        "Allow customer reviews?": "reviews_allowed",
        "Purchase note": "purchase_note",
        "Sale price": "sale_price",
        "Regular price": "regular_price",
        "Categories": "categories",
        "Tags": "tags",
        "Shipping class": "shipping_class",
        "Images": "images",
        "Download limit": "download_limit",
        "Download expiry days": "download_expiry",
        "Parent": "parent_id",
        "Grouped products": "grouped_products",
        "Upsells": "upsell_ids",
        "Cross-sells": "cross_sell_ids",
        "External URL": "external_url",
        "Button text": "button_text",
        "Position": "menu_order",
    };


    const generateCSVData = () => {
        if (!products || products.length === 0) {
            console.warn("No products found.");
            return;
        }

        const headers = selectedColumns.map(col => ({
            label: col,
            key: col,
        }));

        const filteredProducts = products.filter(product =>
            selectedTypes.includes(product.type) &&
            product.categories.some(category => selectedCategories.includes(Number(category.id)))
        );

        if (filteredProducts.length === 0) {
            console.warn("No products match the filters.");
            return;
        }

        const data = filteredProducts.map(product => {
            return headers.reduce((acc, { key }) => {
                const productKey = fieldMapping[key] || key;

                const value = productKey.includes(".")
                    ? productKey.split(".").reduce((obj, k) => (obj && obj[k] ? obj[k] : ""), product)
                    : product[productKey];

                switch (key) {
                    case "Categories":
                        acc[key] = product.categories?.map(cat => cat.name).join(", ") || "";
                        break;
                    case "Tags":
                        acc[key] = product.tags?.map(tag => tag.name).join(", ") || "";
                        break;
                    case "Images":
                        acc[key] = product.images?.map(img => img.src).join(", ") || "";
                        break;
                    case "In stock?":
                        acc[key] = product.stock_quantity > 0 ? "In Stock" : "Out of Stock";
                        break;
                    case "Description":
                        acc[key] = product.description || "";
                        break;
                    default:
                        acc[key] = value ?? "";
                }

                return acc;
            }, {});
        });

        console.log("Generated CSV Data:", data);

        setCsvData({
            headers: headers.map(header => header.label),
            products: data,
        });
    };

    
    const downloadCSV = () => {
        if (!csvData || !csvData.products || csvData.products.length === 0) {
            console.warn("No data available for CSV export.");
            return;
        }

        const csv = Papa?.unparse({
            fields: csvData.headers,
            data: csvData.products.map(product =>
                csvData.headers.map(header => product[header] || "")
            ),
        });
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "exported-products.csv");
        setCsvData({ headers: [], products: [] })
        onClose(false)
    };

    return (
        <Modal width={799}  title="Export products to a CSV file" open={visible} onCancel={() => onClose(false)} footer={null}>
            <Typography.Title level={5}>
                This tool allows you to generate and download a CSV file containing a list of all products.
            </Typography.Title>
            <Form layout="vertical" style={{ marginTop: 20 }}>
                <Form.Item label="Which columns should be exported?">
                    <Checkbox checked={selectAll} onChange={handleSelectAll}>Select All</Checkbox>
                    <Select placeholder={'Slect columns'} mode="multiple" value={selectedColumns} onChange={setSelectedColumns} style={{ width: "100%" }}>
                        {columns.map(col => <Option key={col} value={col}>{col}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="Which product types should be exported?">
                    <Select placeholder={'Slect product type'} mode="multiple" value={selectedTypes} onChange={setSelectedTypes} style={{ width: "100%" }}>
                        <Option value="simple">Simple</Option>
                        <Option value="variable">Variable</Option>
                        <Option value="auction">Auction</Option>
                    </Select>
                </Form.Item>

                <Form.Item  label="Which product category should be exported?">
                    <Select placeholder={'Slect categories'} mode="multiple" value={selectedCategories} onChange={setSelectedCategories} style={{ width: "100%" }}>
                        {parentCategories?.map(cat => <Option key={cat.id} value={cat.id}>{cat.name}</Option>)}
                    </Select>
                </Form.Item>

                {/* <Form.Item>
                    <Checkbox checked={exportMeta} onChange={e => setExportMeta(e.target.checked)}>
                        Yes, export all custom meta
                    </Checkbox>
                </Form.Item> */}
                <Flex gap={10}>
                    {
                      csvData?.products?.length && csvData?.headers?.length && selectedCategories?.length && selectedColumns?.length && selectedTypes?.length?
                      <Button 
                      disabled={selectedCategories?.length && selectedColumns?.length && selectedTypes?.length?false:true}
                      style={{ background: "#1677ff", color: "white" }} onClick={downloadCSV} type="primary" >Download CSV</Button>:
                      <Button style={{ background: "#1677ff", color: "white" }} onClick={generateCSVData} type="primary"  >Generate CSV</Button>
                    }
                </Flex>
            </Form>
        </Modal>
    );
};

export default ExportProductsModal;
